import {Component, Input, OnInit} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";

enum PageMessageIconsEnum {
  PENCIL_CASE   = 'pencil-case',
  APPLICATION   = 'application',
  DEAL          = 'deal',
  BUSINESSMAN   = 'businessman'
}

@ComponentAsElement('v-page-message-element')
@Component({
  selector: 'v-page-message',
  templateUrl: './page-message.component.html',
  styleUrls: []
})
export class PageMessageComponent implements OnInit{
  readonly MAIN_CONTAINER_CLASS = 'trendyopticians';
  public showButton: boolean = false;

  @Input()
  public headerText: string;

  @Input()
  public contentText: string;

  @Input()
  public buttonText: string;

  @Input()
  public nameIcon: string;

  @Input()
  public buttonUrl: string;

  @Input()
  public containerClass: string;

  ngOnInit() {
    this.showButton = !!this.buttonText && !!this.buttonUrl;
  }

  public getContainerClass() {
    return this.containerClass || this.MAIN_CONTAINER_CLASS;
  }

  public getIconClassName() {
    const icon = PageMessageIconsEnum[this.nameIcon];
    return (!!icon) ? 'flaticon-'+icon : '';
  }
}
